import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _jsxFileName = "/home/christian/DEV/workspace/crossbuilders/form-library/src/lib/components/fields/FileDropUpload/index.jsx";
var _excluded = ["showError", "noButton", "name", "className", "multiple", "disabled", "errors", "onChange", "onDrop", "buttonText", "children", "warning", "info"];
import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import classSet from 'react-classset';
import { useDropzone } from 'react-dropzone';
import FormHint from '../../structure/FormHint';

/**
 * FileDropUpload
 * Nimmt Dateien via Drag&Drop oder File Dialog entgegen.
 *
 * @param props {Object} Properties des Element
 * @param props.onDrop {Function} Eventlistener der onChange und onDrop feuert.
 * @returns {*}
 * @constructor
 */
export function FileDropUpload(props) {
  var showError = props.showError,
    noButton = props.noButton,
    name = props.name,
    className = props.className,
    multiple = props.multiple,
    disabled = props.disabled,
    errors = props.errors,
    onChange = props.onChange,
    onDrop = props.onDrop,
    buttonText = props.buttonText,
    children = props.children,
    warning = props.warning,
    info = props.info,
    dropzoneOptions = _objectWithoutProperties(props, _excluded);
  var _useDropzone = useDropzone(_objectSpread({
      multiple: multiple,
      disabled: disabled,
      onDrop: onDrop
    }, dropzoneOptions)),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    open = _useDropzone.open,
    isDragActive = _useDropzone.isDragActive,
    isDragAccept = _useDropzone.isDragAccept,
    isDragReject = _useDropzone.isDragReject,
    isFocused = _useDropzone.isFocused,
    isFileDialogActive = _useDropzone.isFileDialogActive;
  var hasErrors = showError && errors && Object.hasOwnProperty.call(errors, name);
  var errorMessage = hasErrors ? errors[name].message : null;
  return /*#__PURE__*/React.createElement("div", {
    className: classSet(_defineProperty({
      'file-drop-upload': true,
      'disabled': disabled,
      'drag-active': isDragActive,
      'drag-accept': isDragAccept,
      'drag-reject': isDragReject,
      'focused': isFocused,
      'file-dialog-active': isFileDialogActive
    }, className, !!className)),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", Object.assign({}, getRootProps({
    className: 'file-drop-upload__dropzone'
  }), {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("input", Object.assign({
    name: name,
    onChange: onChange
  }, getInputProps(), {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "file-drop-upload__content",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 17
    }
  }, children), !noButton ? /*#__PURE__*/React.createElement("button", {
    className: "file-drop-upload__button",
    type: "button",
    onClick: open,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 21
    }
  }, buttonText) : null), /*#__PURE__*/React.createElement(FormHint, {
    error: errorMessage,
    warning: warning,
    info: info,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 13
    }
  }));
}
export function FileDropUploadControlled(props) {
  var _this = this;
  return /*#__PURE__*/React.createElement(Controller, Object.assign({
    defaultValue: ""
  }, props, {
    render: function render(_ref) {
      var onChange = _ref.onChange,
        onBlur = _ref.onBlur;
      return /*#__PURE__*/React.createElement(FileDropUpload, Object.assign({}, props, {
        noClick: true,
        showError: true,
        onDrop: onChange,
        onBlur: onBlur,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 101,
          columnNumber: 13
        }
      }));
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 9
    }
  }));
}
var fileDropUploadPropTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  showError: PropTypes.bool,
  noButton: PropTypes.bool,
  errors: PropTypes.objectOf(PropTypes.shape({
    message: PropTypes.string,
    type: PropTypes.string
  })),
  warning: PropTypes.string,
  info: PropTypes.string,
  buttonText: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
var fileDropUploadDefaultProps = {
  id: '',
  name: '',
  value: '',
  className: '',
  multiple: true,
  disabled: false,
  showError: false,
  noButton: false,
  errors: {},
  warning: null,
  info: null,
  buttonText: 'Datei auswählen',
  children: /*#__PURE__*/React.createElement("p", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 142,
      columnNumber: 15
    }
  }, "Dateien hierher ziehen oder")
};
FileDropUploadControlled.propTypes = _objectSpread(_objectSpread({}, fileDropUploadPropTypes), {}, {
  control: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});
FileDropUploadControlled.defaultProps = fileDropUploadDefaultProps;
FileDropUpload.propTypes = fileDropUploadPropTypes;
FileDropUpload.defaultProps = fileDropUploadDefaultProps;